import { React, models, kea, history, resources, selectores, componentToRx, Route, match } from "app/main/std";
import { RolCheck } from "./componentes/check";

import { RolTreeFiltradoComponent } from "./componentes/roltreefiltrado";

type Entity = models.Rol;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
}



/**
* Componente para editar un Entity
*/
class RolFormNoRx extends React.PureComponent<Props> {
    getField = kea.formfields(() => this.props);

    render() {
        const { value, onGuardar } = this.props;
        const Text = this.getField(kea.Text);
        return (
            <div>
                <kea.Title titulo="Editar rol" onRegresar={() => history.go("/catalogos/Rol")} />
                <div className="row">
                    <div className="col-md-12">
                        <Text field="Nombre" />
                    </div>
                </div>

                <RolTreeFiltradoComponent value={this.props.value} onChange={this.props.onChange} />

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} />
                    </div>
                </div>
            </div>);
    }
}

export const RolForm = componentToRx(RolFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/form.tsx